import {CONFIG} from "../../config";
import hash from "./../hash";

const groupFacetsByLetter = (facets, facetGroup) => {
    let groupedByLetter = {};
    const LETTER_SLICE = CONFIG.facetGroupLetterSlice;

    if (facets.length <= CONFIG.facetsGroupByLetterMinLen) {
        return;
    }

    if (['krewes'].indexOf(facetGroup) === -1) {
        return;
    }

    if (['__year'].indexOf(facetGroup) !== -1) {
        return;
    }

    facets.forEach(facet => {
        const letter = ((facet.label.match(/[a-z]/i) || []).pop() || facet.label.substr(0, 1)).toUpperCase();
        if (!groupedByLetter[letter]) {
            groupedByLetter[letter] = [];
        }

        groupedByLetter[letter].push(facet);
    });

    groupedByLetter = Object.keys(groupedByLetter).sort()
        .reduce(function (acc, key) {
            acc[key] = groupedByLetter[key];
            return acc;
        }, {});

    let groups = [];

    const keys = Object.keys(groupedByLetter);

    for (let i = 0; i < keys.length; i++) {
        const end = Math.min(i + LETTER_SLICE - 1, keys.length - 1);
        const label = `[${keys[i]}-${keys[end] === keys[i] ? 'Z' : keys[end]}]`;
        const id = hash(`${facetGroup}-${label}`, 'g');


        let children = [];

        for (let k = i; k <= end; k++) {
            children = [...children, ...groupedByLetter[keys[k]]];
        }

        groups.push({
            label,
            count: children.length,
            isNested: true,
            id,
            children
        });

        i = end;
    }

    return groups;
};

export default groupFacetsByLetter;